import { FunctionComponent, h } from 'preact'
import { classNames } from '../../../services/css'
import styles from './page.scss'

export const Page: FunctionComponent<{ className?: string }> = ({
	children,
	className,
}) => <div className={classNames(styles.page, className)}>{children}</div>
